'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as ReactAriaButton, GridList as ReactAriaGridList, GridListItem as ReactAriaGridListItem, } from 'react-aria-components';
import { toClassName } from '../../utils/ClassNameUtils.js';
import { extractLayoutProps, toSpacingClassName, } from '../../utils/LayoutPropsUtils.js';
import { Icon } from '../Icon/Icon.js';
export { useDragAndDrop } from 'react-aria-components';
export function GridList(props) {
    return _jsx(ReactAriaGridList, { ...props });
}
export function GridListItem({ className, ...props }) {
    const { layoutProps, otherProps } = extractLayoutProps(props);
    return (_jsx(ReactAriaGridListItem, { className: toClassName(toSpacingClassName(layoutProps), className), ...otherProps }));
}
export function GridListDragHandle(_props) {
    return (_jsx(ReactAriaButton, { className: "react-aria-Button blank", slot: "drag", children: _jsx(Icon, { icon: "grip" }) }));
}
//# sourceMappingURL=GridList.js.map